/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type ObservationLevel = "DEBUG" | "DEFAULT" | "WARNING" | "ERROR";
export const ObservationLevel = {
  Debug: "DEBUG",
  Default: "DEFAULT",
  Warning: "WARNING",
  Error: "ERROR",
} as const;
